import { LmgService } from "../resource";

// Branch Money (Phase 4) — read-only reports for the branch cash pool.
// Two independent fetches, each seq-guarded so a slow earlier response can't
// clobber a newer one (mirrors lmg_finance_module's pattern).
const BranchMoneyModule = {
  namespaced: true,
  state: {
    // Pool balance (Datum). Defensive defaults so the view can read fields
    // before the first fetch resolves without optional-chaining everywhere.
    balance: {
      ByType: [],
      ByAccount: [],
      Total: { sum_in: 0, sum_out: 0, balance: 0 },
      Movement: { has_range: false, sum_in: 0, sum_out: 0, balance: 0 },
    },
    // Per-policy status list (Data).
    policyStatus: [],
    isLoadingBalance: false,
    isLoadingPolicyStatus: false,
    _balanceSeq: 0,
    _policySeq: 0,
  },
  mutations: {
    SET_BALANCE(state, payload) {
      state.balance = payload;
    },
    SET_POLICY_STATUS(state, payload) {
      state.policyStatus = payload;
    },
  },
  actions: {
    async loadBalance({ commit, state }, payload) {
      state._balanceSeq += 1;
      const mySeq = state._balanceSeq;
      state.isLoadingBalance = true;
      const empty = {
        ByType: [],
        ByAccount: [],
        Total: { sum_in: 0, sum_out: 0, balance: 0 },
        Movement: { has_range: false, sum_in: 0, sum_out: 0, balance: 0 },
      };
      try {
        const data = await LmgService.BranchMoneyBalance(payload);
        if (mySeq !== state._balanceSeq) return;
        // Backend uses r.Set → object payload lands on Datum, not Data.
        commit("SET_BALANCE", data.data.Datum || empty);
        state.isLoadingBalance = false;
      } catch (err) {
        if (mySeq !== state._balanceSeq) return;
        commit("SET_BALANCE", empty);
        state.isLoadingBalance = false;
      }
    },
    async loadPolicyStatus({ commit, state }, payload) {
      state._policySeq += 1;
      const mySeq = state._policySeq;
      state.isLoadingPolicyStatus = true;
      try {
        const data = await LmgService.BranchMoneyPolicyStatus(payload);
        if (mySeq !== state._policySeq) return;
        commit("SET_POLICY_STATUS", data.data.Data == null ? [] : data.data.Data);
        state.isLoadingPolicyStatus = false;
      } catch (err) {
        if (mySeq !== state._policySeq) return;
        commit("SET_POLICY_STATUS", []);
        state.isLoadingPolicyStatus = false;
      }
    },
  },
  getters: {
    getBalance(state) {
      return state.balance;
    },
    getPolicyStatus(state) {
      return state.policyStatus;
    },
    isLoadingBalance(state) {
      return state.isLoadingBalance;
    },
    isLoadingPolicyStatus(state) {
      return state.isLoadingPolicyStatus;
    },
  },
};

export default BranchMoneyModule;
